import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" fill="currentColor">
  <path d="M12 22.2033C10.5848 22.2033 9.25694 21.9357 8.0164 21.4004C6.77587 20.8651 5.69678 20.1386 4.77913 19.2209C3.86148 18.3033 3.135 17.2242 2.5997 15.9837C2.0644 14.7431 1.79675 13.4153 1.79675 12C1.79675 10.5848 2.0644 9.25695 2.5997 8.01641C3.135 6.77588 3.86148 5.69678 4.77913 4.77913C5.69678 3.86148 6.77587 3.135 8.0164 2.5997C9.25694 2.0644 10.5848 1.79675 12 1.79675C13.4152 1.79675 14.7431 2.0644 15.9837 2.5997C17.2242 3.135 18.3033 3.86148 19.2209 4.77913C20.1386 5.69678 20.8651 6.77588 21.4004 8.01641C21.9357 9.25695 22.2033 10.5848 22.2033 12C22.2033 13.4153 21.9357 14.7431 21.4004 15.9837C20.8651 17.2242 20.1386 18.3033 19.2209 19.2209C18.3033 20.1386 17.2242 20.8651 15.9837 21.4004C14.7431 21.9357 13.4152 22.2033 12 22.2033ZM12 19.9283C14.2174 19.9283 16.0931 19.1613 17.6272 17.6272C19.1613 16.0932 19.9283 14.2174 19.9283 12C19.9283 9.78265 19.1613 7.90693 17.6272 6.37286C16.0931 4.83881 14.2174 4.07178 12 4.07178C9.78264 4.07178 7.90692 4.83881 6.37285 6.37286C4.8388 7.90693 4.07178 9.78265 4.07178 12C4.07178 14.2174 4.8388 16.0932 6.37285 17.6272C7.90692 19.1613 9.78264 19.9283 12 19.9283Z"/>
  <circle cx="12" cy="12" r="9" style="fill: var(--hover-color)"/>
  <circle cx="12" style="fill: var(--active-color)" cy="12" r="6"/>
</svg>`;

const Radio = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='radio' svg={svg} {...props} />
  )
);

Radio.displayName = 'RadioIcon';

export default Radio;
